import { AbstractAnalyticsTracker } from '@inter-ikea-kompis/analytics';
import type { IDexfSettings } from '@inter-ikea-kompis/types';

import { IpexMomentEnum } from '@insights/insights-data-provider';

import type { ZipInActionEnum } from '../../src/index.js';

const moduleId = 'zip_in';

/**
 * @event zip_code_action When an action is performed in the zip in sheet.
 */
export default class ZipInTracker extends AbstractAnalyticsTracker {
	constructor(options: {
		dev: boolean;
		ab?: boolean;
		settings: IDexfSettings;
		locale: string;
		reporterId?: string;
	}) {
		super({ moduleId, ...options });
	}

	public sendZipCodeAction(action: ZipInActionEnum): void {
		const payload = {
			common: { component: moduleId },
			data: {
				action
			}
		};

		this.getReporter().report({
			event: 'zip_code_action',
			ipexMoment: IpexMomentEnum.showMe,
			payload
		});
	}
}
